module.exports = __webpack_public_path__ + "static/media/chevron-left-white.dba147f7.svg";